export interface DocumentInterface {
    id: number;
    fileName: string;
    path: string;
    title: string;
    accessUrl?: string;
    points?: number;
}

export class Document implements DocumentInterface {
    public id: number;
    public fileName: string;
    public path: string;
    public title: string;
    public accessUrl?: string;
    public points?: number;

    constructor(
        id: number,
        fileName: string,
        path: string,
        title: string,
        accessUrl?: string,
        points?: number
    ) {
        this.id = id;
        this.fileName = fileName;
        this.path = path;
        this.title = title;
        this.accessUrl = accessUrl;
        this.points = points;
    }

    static fromJson(json: any): Document {
        return new Document(
            json.id,
            json.fileName,
            json.path,
            json.title,
            json.accessUrl,
            json.points
        );
    }

    static fromJsonArray(jsonArray: any[]): Document[] {
        return jsonArray.map(item => Document.fromJson(item));
    }
}